module.exports = __webpack_public_path__ + "static/img/dynamicg.d638534.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicg.png
// module id = q+Ok
// module chunks = 45